import mermaid from "mermaid";
import type React from "react";
import { useEffect, useRef, useState } from "react";

interface MermaidProps {
	chart: string;
}

let isInitialized = false;

export const Mermaid: React.FC<MermaidProps> = ({ chart }) => {
	const ref = useRef<HTMLDivElement>(null);
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		if (!isInitialized) {
			mermaid.initialize({
				startOnLoad: false,
				theme: "default",
				securityLevel: "loose",
			});
			isInitialized = true;
		}

		if (ref.current) {
			const renderChart = async () => {
				try {
					// Re-render when chart changes
					ref.current?.removeAttribute("data-processed");
					const id = `mermaid-${Math.random().toString(36).substring(2, 11)}`;
					const { svg } = await mermaid.render(id, chart);
					if (ref.current) {
						ref.current.innerHTML = svg;
					}
				} catch (err) {
					console.error("Mermaid render error:", err);
					setError("Failed to render diagram");
				}
			};

			renderChart();
		}
	}, [chart]);

	if (error) {
		return <pre className="mermaid-error">{chart}</pre>;
	}

	return (
		<div className="mermaid" ref={ref}>
			{chart}
		</div>
	);
};
